import { useState } from 'react'

import LoginCard from '../Components/Pages/Login/LoginCard'

import { Environments } from '@/Components/EnvBanner'
import UnauthenticatedLayout from '@/Components/Layout/UnauthenticatedLayout'
import PasswordChangeCard from '@/Components/Pages/Login/PasswordChangeCard'

export type LoginPageProps = {
  env: Environments
}

const LoginPage: React.FC<LoginPageProps> = ({ env }) => {
  const [changingPassword, setChangingPassword] = useState<boolean>(false)

  return (
    <UnauthenticatedLayout env={env}>
      {!changingPassword && (
        <LoginCard changePassword={() => setChangingPassword((v) => !v)} />
      )}
      {changingPassword && (
        <PasswordChangeCard
          returnToLogin={() => setChangingPassword((v) => !v)}
        />
      )}
    </UnauthenticatedLayout>
  )
}

export default LoginPage
